import React from 'react';

import './title.scss';

export const TitleSize = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'H5',
  H6: 'h6',
};

export const TitleColor = {
  white: 'white',
  black: 'black',
};

export const TitleLevel = {
  H1: '1',
  H2: '2',
  H3: '3',
  H4: '4',
  H5: '5',
  H6: '6',
};

export function Title({level = 1, size, color, extraClassName, children}) {
  return React.createElement(
    `h${level}`,
    {
      className: `title${size ? ` title__${size}` : ''} title${
        color ? ` title__${color}` : ''
      } ${extraClassName}`,
    },
    children,
  );
}
